import { render } from "./swift-confrim.vue?vue&type=template&id=bd511d7c&ts=true"
import script from "./swift-confrim.vue?vue&type=script&lang=ts"
export * from "./swift-confrim.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__